export default __webpack_public_path__ + "static/media/digita-logo-hybriditv-dark.8f38876e.svg";